<ng-container *ngIf="def != null && _options != null">
    <sm-toolbar>
        <p-button icon="fas fa-run" label="Export starten" (onClick)="export()"></p-button>
        <p-button icon="fas fa-save" label="Exportkonfiguration in Datei speichern" (onClick)="saveConfig()"></p-button>
        <p-button icon="fas fa-open" label="Exportkonfiguration aus Datei laden" (onClick)="loadConfig()"></p-button>
        <p-button icon="fas fa-times" label="Abbrechen" (onClick)="cancel()"></p-button>
    </sm-toolbar>
    <sm-form [form]="form">
    </sm-form>
    <p-panel *ngFor="let archive of _options.archives; index as index" [header]="'Schrank ' + archive.archive.getBestDisplayName()">
        <sm-form [form]="forms[index]">
        </sm-form>
        <sm-table2 class="height300p" [data]="tables[index]" [autoHeight]=true></sm-table2>
</p-panel>
</ng-container>
